import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=0ebc2cd2&scoped=true&"
import script from "./ProcessCOCOS.vue?vue&type=script&lang=js&"
export * from "./ProcessCOCOS.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=0ebc2cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebc2cd2",
  null
  
)

export default component.exports